// Environment variable validation helper
const validateSampleRate = (value: string | undefined): number => {
  if (!value) return 0.2;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) || parsed < 0 || parsed > 1 ? 0.2 : parsed;
};

// Type-safe environment mapping
type SentryEnvironment =
  | "Production"
  | "Sandbox"
  | "Staging"
  | "Development"
  | "Review";

const ENVIRONMENT_MAP: Record<string, SentryEnvironment> = {
  production: "Production",
  sandbox: "Sandbox",
  staging: "Staging",
  main: "Development",
} as const;

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const TRACES_SAMPLE_RATE =
  process.env.TRACES_SAMPLE_RATE ?? process.env.NEXT_PUBLIC_TRACES_SAMPLE_RATE;

export const sentryOptions = {
  // TODO: set SENTRY_RELEASE based on tag
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  dsn: SENTRY_DSN,
  enabled: process.env.NODE_ENV === "production",
  environment:
    ENVIRONMENT_MAP[process.env.NEXT_PUBLIC_APP_ENV || ""] || "Review",
  tracesSampleRate: validateSampleRate(TRACES_SAMPLE_RATE),
  denyUrls: [
    // Threatmetrix leaking errors
    /^https:\/\/r\.hokodo\.co/i,
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
  ],
};
